import { adStylesMock } from "@/feature/ads/mock/adStyles.mock";
import type { AdStyle, StyleTab } from "./types";

function mockToAdStyle(
  mock: { id: string; image_url: string; name?: string; name_id?: string },
  category: string,
  isCustomCategory?: boolean
): AdStyle {
  return {
    id: mock.id,
    coverImage: mock.image_url,
    name: mock.name ?? "Estilo",
    name_id: mock.name_id,
    category,
    image_url: mock.image_url,
    isCustomUpload: isCustomCategory ?? false,
  };
}

const CUSTOM_REFERENCE_STYLE: AdStyle = {
  ...mockToAdStyle(
    { id: "custom-reference", image_url: "", name: "Personalizada", name_id: "custom-reference" },
    "custom",
    true
  ),
  description: "custom-reference-style-description",
};

export const MOCK_STYLES: AdStyle[] = (() => {
  const fromMock = adStylesMock.flatMap((cat) =>
    cat.images.map((img) => mockToAdStyle(img, cat.category, cat.isCustom === true))
  );
  const hasCustomRef = fromMock.some((s) => s.id === "custom-reference" && s.isCustomUpload);
  return hasCustomRef ? fromMock : [...fromMock, CUSTOM_REFERENCE_STYLE];
})();

export function getStylesByCategory(tab: StyleTab): AdStyle[] {
  if (tab === "all") {
    return MOCK_STYLES;
  }
  if (tab === "custom") {
    const categoryData = adStylesMock.find((c) => c.category === "custom");
    const images = categoryData?.images;
    const customStyles =
      images && images.length > 0
        ? images.map((img) => mockToAdStyle(img, "custom", true))
        : [CUSTOM_REFERENCE_STYLE];
    return customStyles;
  }
  const category = tab === "offer" ? "offer" : tab === "testimonials" ? "testimonials" : "viral";
  const categoryData = adStylesMock.find((c) => c.category === category);
  if (!categoryData) return [];
  return categoryData.images.map((img) => mockToAdStyle(img, category));
}
